import React from 'react';
import { StanBarChart, StanLineChart, StanSimpleBarChart } from '@/components';

export default function InternalsChartsPage() {
    // Demo data matching Vue defaults
    const testData = {
        distinct_fans_opened: [
            {
                user_fan_id: 190437,
                user_id: 26187082,
                fan_id: 109486,
                name: 'Bob',
                email: 'bob@gmail.com',
                phone_number: '',
                data: {
                    questions: null,
                    communication_preferences: 'subscribed',
                },
            },
            {
                user_fan_id: 241384,
                user_id: 26187082,
                fan_id: 158517,
                name: 'jeef123123',
                email: 'jeef1231231@gmail.com',
                phone_number: '',
                data: {
                    questions: null,
                    communication_preferences: 'subscribed',
                },
            },
            {
                user_fan_id: 241383,
                user_id: 26187082,
                fan_id: 158516,
                name: 'jeef',
                email: 'jeef123@gmail.com',
                phone_number: '',
                data: {
                    questions: null,
                    communication_preferences: 'subscribed',
                },
            },
        ],
        distinct_fans_clicked: [],
        email_open_rates: [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 60, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        ],
        email_click_rates: [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        ],
        dates: [
            'Dec 01',
            'Dec 02',
            'Dec 03',
            'Dec 04',
            'Dec 05',
            'Dec 06',
            'Dec 07',
            'Dec 08',
            'Dec 09',
            'Dec 10',
            'Dec 11',
            'Dec 12',
            'Dec 13',
            'Dec 14',
            'Dec 15',
            'Dec 16',
            'Dec 17',
            'Dec 18',
            'Dec 19',
            'Dec 20',
            'Dec 21',
            'Dec 22',
            'Dec 23',
            'Dec 24',
            'Dec 25',
            'Dec 26',
            'Dec 27',
            'Dec 28',
            'Dec 29',
            'Dec 30',
            'Dec 31',
            'Jan 01',
            'Jan 02',
            'Jan 03',
            'Jan 04',
            'Jan 05',
            'Jan 06',
            'Jan 07',
            'Jan 08',
            'Jan 09',
            'Jan 10',
            'Jan 11',
            'Jan 12',
            'Jan 13',
            'Jan 14',
            'Jan 15',
            'Jan 16',
            'Jan 17',
            'Jan 18',
            'Jan 19',
            'Jan 20',
            'Jan 21',
            'Jan 22',
            'Jan 23',
            'Jan 24',
            'Jan 25',
            'Jan 26',
            'Jan 27',
            'Jan 28',
            'Jan 29',
            'Jan 30',
            'Jan 31',
            'Feb 01',
            'Feb 02',
            'Feb 03',
            'Feb 04',
            'Feb 05',
            'Feb 06',
            'Feb 07',
            'Feb 08',
            'Feb 09',
            'Feb 10',
            'Feb 11',
            'Feb 12',
            'Feb 13',
            'Feb 14',
            'Feb 15',
            'Feb 16',
            'Feb 17',
            'Feb 18',
            'Feb 19',
            'Feb 20',
            'Feb 21',
            'Feb 22',
            'Feb 23',
            'Feb 24',
            'Feb 25',
            'Feb 26',
            'Feb 27',
            'Feb 28',
            'Mar 01',
            'Mar 02',
            'Mar 03',
            'Mar 04',
            'Mar 05',
            'Mar 06',
            'Mar 07',
            'Mar 08',
            'Mar 09',
            'Mar 10',
            'Mar 11',
            'Mar 12',
            'Mar 13',
            'Mar 14',
            'Mar 15',
            'Mar 16',
            'Mar 17',
            'Mar 18',
            'Mar 19',
            'Mar 20',
            'Mar 21',
            'Mar 22',
            'Mar 23',
            'Mar 24',
            'Mar 25',
            'Mar 26',
            'Mar 27',
            'Mar 28',
            'Mar 29',
            'Mar 30',
            'Mar 31',
            'Apr 01',
            'Apr 02',
            'Apr 03',
            'Apr 04',
            'Apr 05',
            'Apr 06',
            'Apr 07',
            'Apr 08',
            'Apr 09',
            'Apr 10',
            'Apr 11',
            'Apr 12',
            'Apr 13',
            'Apr 14',
            'Apr 15',
            'Apr 16',
            'Apr 17',
            'Apr 18',
            'Apr 19',
            'Apr 20',
            'Apr 21',
            'Apr 22',
            'Apr 23',
            'Apr 24',
            'Apr 25',
            'Apr 26',
            'Apr 27',
            'Apr 28',
            'Apr 29',
            'Apr 30',
            'May 01',
            'May 02',
            'May 03',
            'May 04',
            'May 05',
            'May 06',
            'May 07',
            'May 08',
            'May 09',
            'May 10',
            'May 11',
            'May 12',
            'May 13',
            'May 14',
            'May 15',
            'May 16',
            'May 17',
            'May 18',
            'May 19',
            'May 20',
            'May 21',
            'May 22',
            'May 23',
            'May 24',
            'May 25',
            'May 26',
            'May 27',
            'May 28',
            'May 29',
            'May 30',
            'May 31',
            'Jun 01',
            'Jun 02',
            'Jun 03',
            'Jun 04',
            'Jun 05',
            'Jun 06',
            'Jun 07',
            'Jun 08',
            'Jun 09',
            'Jun 10',
            'Jun 11',
            'Jun 12',
            'Jun 13',
            'Jun 14',
            'Jun 15',
            'Jun 16',
            'Jun 17',
            'Jun 18',
            'Jun 19',
            'Jun 20',
            'Jun 21',
            'Jun 22',
            'Jun 23',
            'Jun 24',
            'Jun 25',
            'Jun 26',
            'Jun 27',
            'Jun 28',
            'Jun 29',
            'Jun 30',
            'Jul 01',
            'Jul 02',
            'Jul 03',
            'Jul 04',
            'Jul 05',
            'Jul 06',
            'Jul 07',
            'Jul 08',
            'Jul 09',
            'Jul 10',
            'Jul 11',
            'Jul 12',
            'Jul 13',
            'Jul 14',
            'Jul 15',
            'Jul 16',
            'Jul 17',
            'Jul 18',
            'Jul 19',
            'Jul 20',
            'Jul 21',
            'Jul 22',
            'Jul 23',
            'Jul 24',
            'Jul 25',
            'Jul 26',
            'Jul 27',
            'Jul 28',
            'Jul 29',
            'Jul 30',
            'Jul 31',
            'Aug 01',
            'Aug 02',
            'Aug 03',
            'Aug 04',
            'Aug 05',
            'Aug 06',
            'Aug 07',
            'Aug 08',
            'Aug 09',
            'Aug 10',
            'Aug 11',
            'Aug 12',
            'Aug 13',
            'Aug 14',
            'Aug 15',
            'Aug 16',
            'Aug 17',
            'Aug 18',
            'Aug 19',
            'Aug 20',
            'Aug 21',
            'Aug 22',
            'Aug 23',
            'Aug 24',
            'Aug 25',
            'Aug 26',
            'Aug 27',
            'Aug 28',
            'Aug 29',
            'Aug 30',
            'Aug 31',
            'Sep 01',
            'Sep 02',
            'Sep 03',
            'Sep 04',
            'Sep 05',
            'Sep 06',
            'Sep 07',
            'Sep 08',
            'Sep 09',
            'Sep 10',
            'Sep 11',
            'Sep 12',
            'Sep 13',
            'Sep 14',
            'Sep 15',
            'Sep 16',
            'Sep 17',
            'Sep 18',
            'Sep 19',
            'Sep 20',
            'Sep 21',
            'Sep 22',
            'Sep 23',
            'Sep 24',
            'Sep 25',
            'Sep 26',
            'Sep 27',
            'Sep 28',
            'Sep 29',
            'Sep 30',
        ],
        delivered: 5,
        opens: 3,
        clicks: 0,
        bounces: 0,
        ctr: 0,
        ctor: 0,
    };
    const areaSeries = {
        series: [
            {
                name: 'Total Revenue',
                data: [
                    1743347.91, 1743347.91, 1743347.91, 1743347.91, 1743347.91, 1743347.91, 1743347.91, 1743347.91,
                    1744347.91, 1744347.91, 1744347.91, 1744347.91, 1744347.91, 1744347.91, 1744347.91, 1744347.91,
                    1744347.91, 1744347.91, 1744347.91, 1744347.91, 1744347.91, 1744347.91, 1744347.91, 1744347.91,
                    1744347.91, 1744347.91, 1744347.91, 1744347.91, 1744347.91, 1783347.88,
                ],
            },
        ],
        options: {
            yaxis: {
                min: 1723347.9249999998,
            },
            xaxis: {
                categories: [
                    'Sep. 09',
                    'Sep. 10',
                    'Sep. 11',
                    'Sep. 12',
                    'Sep. 13',
                    'Sep. 14',
                    'Sep. 15',
                    'Sep. 16',
                    'Sep. 17',
                    'Sep. 18',
                    'Sep. 19',
                    'Sep. 20',
                    'Sep. 21',
                    'Sep. 22',
                    'Sep. 23',
                    'Sep. 24',
                    'Sep. 25',
                    'Sep. 26',
                    'Sep. 27',
                    'Sep. 28',
                    'Sep. 29',
                    'Sep. 30',
                    'Oct. 01',
                    'Oct. 02',
                    'Oct. 03',
                    'Oct. 04',
                    'Oct. 05',
                    'Oct. 06',
                    'Oct. 07',
                    'Oct. 08',
                ],
            },
        },
    };

    const flowSeries = [
        { name: 'Click Rate', data: testData.email_click_rates, color: 'green' },
        { name: 'Open Rate', data: testData.email_open_rates, color: 'blue' },
    ];
    const flowCategories = testData.dates;

    // Bar chart demo data
    const barSeries = [
        {
            name: 'Store Visits',
            data: [120, 340, 280, 450, 390, 520, 610, 490, 560, 630],
        },
    ];

    const barCategories = ['Jan 1', 'Jan 2', 'Jan 3', 'Jan 4', 'Jan 5', 'Jan 6', 'Jan 7', 'Jan 8', 'Jan 9', 'Jan 10'];

    // Stacked bar chart demo data
    const stackedBarSeries = [
        { name: 'Product A', data: [44, 55, 41, 67, 22, 43, 21, 49, 67, 82] },
        { name: 'Product B', data: [13, 23, 20, 8, 13, 27, 33, 12, 21, 44] },
        { name: 'Product C', data: [11, 17, 15, 15, 21, 14, 15, 23, 31, 29] },
    ];

    // Simple horizontal bar demo data
    const simpleBarData = {
        'Product A': 4500,
        'Product B': 3200,
        'Product C': 2800,
        'Product D': 1500,
        'Product E': 900,
        'Product F': 600,
        'Product G': 400,
    };

    return (
        <div className='bg- grid grid-cols-1 gap-4 rounded-lg border border-gray-200 xl:grid-cols-2'>
            <div className='col-span-2 p-4'>
                <h3 className='mb-4 text-sm font-medium text-gray-700'>Area Chart</h3>
                <StanLineChart
                    series={areaSeries.series}
                    className='mt-6'
                    customOptions={areaSeries.options}
                    type='area'
                    height={220}
                    chartPrefix=''
                    label={<span className='text-sm'>Last 10 Days</span>}
                    num={<span>$9.1k</span>}
                />
            </div>
            <div className='col-span-2 p-4'>
                <h3 className='mb-4 text-sm font-medium text-gray-700'>Line Chart</h3>
                <StanLineChart
                    className='mt-6'
                    series={flowSeries}
                    type='line'
                    categories={flowCategories}
                    height={320}
                    chartPrefix=''
                    dataSuffix='%'
                    decimals={0}
                />
            </div>
            <div className='col-span-2 p-4'>
                <h3 className='mb-4 text-sm font-medium text-gray-700'>Bar Chart</h3>
                <StanBarChart
                    className='mt-6'
                    series={barSeries}
                    categories={barCategories}
                    height={379}
                    chartPrefix=''
                    decimals={0}
                    color='#22EDC8'
                />
            </div>
            <div className='col-span-2 p-4'>
                <h3 className='mb-4 text-sm font-medium text-gray-700'>Stacked Bar Chart</h3>
                <StanBarChart
                    className='mt-6'
                    series={stackedBarSeries}
                    categories={barCategories}
                    height={379}
                    chartPrefix='$'
                    decimals={0}
                    stacked
                    color='#A56EFF'
                />
            </div>
            <div className='col-span-2 p-4'>
                <h3 className='mb-4 text-sm font-medium text-gray-700'>Simple Horizontal Bar Chart</h3>
                <StanSimpleBarChart
                    className='mt-6'
                    totals={simpleBarData}
                    formatter={(val: number) => `$${val.toLocaleString()}`}
                    showTopN={5}
                    otherLabel='Other Products'
                    color='#FF7EDB'
                />
            </div>
        </div>
    );
}
